// extracted by mini-css-extract-plugin
export default {"wrapper":"ResendLinkActivation_wrapper__JNFaN","box":"ResendLinkActivation_box__p1evl","form":"ResendLinkActivation_form__JD+6I","notice":"ResendLinkActivation_notice__kTlww"};